// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir=ltr] .radioButton--EMuqx {
  margin-right: 5px;
}[dir=rtl] .radioButton--EMuqx {
  margin-left: 5px;
}

[dir=ltr] .expandIcon--uwOlB {
  margin-left: 5px;
}

[dir=rtl] .expandIcon--uwOlB {
  margin-right: 5px;
}

[dir=ltr] .shareButtonIcon--rHL1n {
  margin-right: 4px;
}

[dir=rtl] .shareButtonIcon--rHL1n {
  margin-left: 4px;
}

/* Mobile-first: stack vertically */
.subviewWrapper--KassI {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

@media (min-width: 768px) {
  .subviewWrapper--KassI {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }
}

/* Mobile-first: stack vertically */
.optionsWrapper--BKiSH {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

@media (min-width: 768px) {
  .optionsWrapper--BKiSH {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
  }

  /* Vertical divider between the subview group and the chart-type group.
     Only the graph view renders chart-type options; for other views the
     wrapper is empty so we suppress the divider. */
  .optionsWrapper--BKiSH:not(:empty) {
    position: relative;
  }
  [dir=ltr] .optionsWrapper--BKiSH:not(:empty) {
    padding-left: 20px;
  }
  [dir=rtl] .optionsWrapper--BKiSH:not(:empty) {
    padding-right: 20px;
  }

  .optionsWrapper--BKiSH:not(:empty)::before {
    content: '';
    position: absolute;
    top: 50%;
    width: 1px;
    height: 24px;
  }

  [dir] .optionsWrapper--BKiSH:not(:empty)::before {
    transform: translateY(-50%);
    background: #c3c3c3;
  }

  [dir=ltr] .optionsWrapper--BKiSH:not(:empty)::before {
    left: 0;
  }

  [dir=rtl] .optionsWrapper--BKiSH:not(:empty)::before {
    right: 0;
  }
}

.disabledRadioButton--TQ5aG {
  color: #a5a4a4;
}

.disabledRadioButton--TQ5aG img {
  opacity: 0.4;
}

.subviewIcon--l5N84 {
  opacity: 0.6;
}

[dir=ltr] .subviewIcon--l5N84 {
  margin-right: 5px;
}

[dir=rtl] .subviewIcon--l5N84 {
  margin-left: 5px;
}

.selectedLeft--jM9YH {
  font-weight: bold;
}

[dir] .selectedLeft--jM9YH {
  background: RGBA(226, 226, 226, 0.25);
  border: RGB(226, 226, 226) 1px solid;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
}

.selectedRight--J7SFP {
  font-weight: bold;
}

.selectedRight--J7SFP img {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SettingsHeader/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB,CAFA;EACE,gBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAFA;EACE,iBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,gBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;;mDAEiD;EACjD;IACE,kBAAkB;EAEpB;EAHA;IAEE,kBAAkB;EACpB;EAHA;IAEE,mBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAElB,QAAQ;IAER,UAAU;IACV,YAAY;EAEd;;EATA;IAKE,2BAA2B;IAG3B,mBAAmB;EACrB;;EATA;IAGE,OAAO;EAMT;;EATA;IAGE,QAAO;EAMT;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAKA;EAEE,YAAY;AACd;;AAHA;EACE,iBAAiB;AAEnB;;AAHA;EACE,gBAAiB;AAEnB;;AAEA;EAME,iBAAiB;AACnB;;AAPA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,eAAe;AAEjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".radioButton {\n  margin-right: 5px;\n}\n\n.expandIcon {\n  margin-left: 5px;\n}\n\n.shareButtonIcon {\n  margin-right: 4px;\n}\n\n/* Mobile-first: stack vertically */\n.subviewWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n@media (min-width: 768px) {\n  .subviewWrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n}\n\n/* Mobile-first: stack vertically */\n.optionsWrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n@media (min-width: 768px) {\n  .optionsWrapper {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n\n  /* Vertical divider between the subview group and the chart-type group.\n     Only the graph view renders chart-type options; for other views the\n     wrapper is empty so we suppress the divider. */\n  .optionsWrapper:not(:empty) {\n    position: relative;\n    padding-left: 20px;\n  }\n\n  .optionsWrapper:not(:empty)::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 1px;\n    height: 24px;\n    background: #c3c3c3;\n  }\n}\n\n.disabledRadioButton {\n  color: #a5a4a4;\n}\n\n.disabledRadioButton img {\n  opacity: 0.4;\n}\n\n.subviewRadioButton {\n}\n\n.subviewIcon {\n  margin-right: 5px;\n  opacity: 0.6;\n}\n\n.selectedLeft {\n  background: RGBA(226, 226, 226, 0.25);\n  border: RGB(226, 226, 226) 1px solid;\n  border-radius: 5px;\n  padding: 5px;\n  cursor: pointer;\n  font-weight: bold;\n}\n\n.selectedRight {\n  font-weight: bold;\n}\n\n.selectedRight img {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioButton": `radioButton--EMuqx`,
	"expandIcon": `expandIcon--uwOlB`,
	"shareButtonIcon": `shareButtonIcon--rHL1n`,
	"subviewWrapper": `subviewWrapper--KassI`,
	"optionsWrapper": `optionsWrapper--BKiSH`,
	"disabledRadioButton": `disabledRadioButton--TQ5aG`,
	"subviewIcon": `subviewIcon--l5N84`,
	"selectedLeft": `selectedLeft--jM9YH`,
	"selectedRight": `selectedRight--J7SFP`
};
export default ___CSS_LOADER_EXPORT___;
